import React from 'react';
import config from '../appConfig';

export function FeatureToggle({ name, children }) {
  if (config.toggleFeatures[name]) {
    return children;
  }

  return null;
}
